import { CommonModule } from "@angular/common";
import { Component, inject, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { INZorroOutput } from "../../../core/models/common";
import { RestService } from "../../../core/services/rest.service";
import { MaterialModule } from "../../../core/shared/material.module";
import { llmSelectedTestCases } from "../../../core/table-templates/llm-selected-test-cases-table";
import { SharedComponents } from "../../shared.module";

@Component({
  selector: "app-llm-test-cases-modal",
  standalone: true,
  imports: [SharedComponents, CommonModule, MaterialModule],
  templateUrl: "./llm-test-cases-modal.component.html",
  styleUrl: "./llm-test-cases-modal.component.scss",
})
export class LlmTestCasesModalComponent implements OnInit {
  activeModal = inject(NgbActiveModal);
  testcaseSearch = "";
  columnsDetails: any = llmSelectedTestCases;
  isProcessing = false;
  tastcaseDetails: any;
  isDataLoading: boolean = false;

  @Input()
  configs: any = {};

  logOutput: string = "";
  selectedDataList: any = [];
  allTestCases: any = [];

  constructor(private restService: RestService) {}

  ngOnInit() {
    this.isDataLoading = true;
    this.restService
      .getTestCaseByVersionId(
        this.configs?.data?.projectId,
        this.configs?.data?.testCaseVersionId
      )
      .subscribe(
        (item) => {
          const responseTestCases = item?.data?.testCases;
          this.selectedDataList = this.configs?.data?.selectedTestCases;
          this.selectedDataList?.forEach((element: any) => {
            responseTestCases?.forEach((item: any) => {
              if (item?._id === element?._id) {
                item.select = true;
              }
            });
          });
          this.allTestCases = responseTestCases;
          this.tastcaseDetails = responseTestCases;
          this.isDataLoading = false;
        },
        (error) => {
          this.isDataLoading = false;
        }
      );
  }

  searchTestCases() {
    const searchText = this.testcaseSearch.trim().toLowerCase();

    if (!searchText) {
      this.tastcaseDetails = this.allTestCases;
      return;
    }

    this.tastcaseDetails = this.allTestCases.filter((testCase: any) =>
      Object.values(testCase).some(value =>
        String(value ?? '')
          .toLowerCase()
          .includes(searchText)
      )
    );
  }

  onTableActinChange(event: INZorroOutput) {
    let rowId = event.data.row.id;
    if (event.data.columnConfig?.value === "edit") {
    }
  }

  handleRowSelection(event: any) {
    this.selectedDataList = event?.data?.filter((item: any) => item.select);
  }

  onToggleChange(event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
      this.tastcaseDetails = this.selectedDataList;
    } else {
      this.tastcaseDetails = this.allTestCases;
    }
  }

  addTestCases() {
    this.activeModal.close({
      totalTestCases: this.allTestCases?.length,
      selectedTestCaseDetails: this.selectedDataList,
    });
  }

  onDiscardSelectedItems() {}
}
